import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import GenericSearchField from "../genericsearchfield/GenericSearchField";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        padding: theme.spacing(1, 2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.secondary.light,
        [theme.breakpoints.up('sm')]: {
            flexWrap: 'nowrap'
        }
    },
    borderRadius: {
        borderRadius: theme.shape.borderRadius
    },
    buttonsDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 1,
        '&.spaceBetween': {
            justifyContent: 'space-between'
        },
        '&.spaceEvenly': {
            justifyContent: 'space-evenly'
        },
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row'
        }
    },
    searchDiv: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 0
    }
}));

export default function ToolBar(props) {
    const {
        children,
        search = false,
        onSearch,
        spaceBetween = false,
        spaceEvenly = false,
        noBorderRadius = false
    } = props;
    const classes = useStyles();

    return (
        <div className={clsx(classes.root, !noBorderRadius && classes.borderRadius)}>
            <div className={clsx(classes.buttonsDiv, spaceBetween && 'spaceBetween', spaceEvenly && 'spaceEvenly')}>
                {children}
            </div>
            {search && (
                <div className={classes.searchDiv}>
                    <GenericSearchField
                        onSearch={onSearch}
                        marginBottom={false} />
                </div>
            )}
        </div>
    );
};

ToolBar.propTypes = {
    search: PropTypes.bool,
    onSearch: PropTypes.func,
    children: PropTypes.any,
    spaceBetween: PropTypes.bool,
    spaceEvenly: PropTypes.bool,
    noBorderRadius: PropTypes.bool
};